import BaseBlock from "@/ts/base/Components/Blocks/BaseBlock";
import Swiper, {Navigation, Pagination, SwiperOptions} from "swiper";

export default class WoocommerceSlider extends BaseBlock {
	protected sliderEl!: HTMLElement;
	protected swiperEl!: HTMLElement;
	protected swiperSlideEl!: NodeListOf<HTMLElement>;

	init(): void {

		this.sliderEl = <HTMLElement>this.block.querySelector('.slider');

		if (this.sliderEl) {
			this.swiperEl = <HTMLElement>this.sliderEl.querySelector('.swiper');

			if (this.swiperEl) {
				this.swiperSlideEl = <NodeListOf<HTMLElement>>this.swiperEl.querySelectorAll('li.product');

				let options: SwiperOptions = {
					loop: true,
					slidesPerView: 1,
					centerInsufficientSlides: true,
					modules: [Navigation, Pagination],
					navigation: {
						nextEl: <HTMLElement>this.block.querySelector(".slider-btn-next"),
						prevEl: <HTMLElement>this.block.querySelector(".slider-btn-prev"),
					},
					pagination: {
						el: <HTMLElement>this.block.querySelector(".slider-pagination")
					},
					breakpoints: {
						576: {
							slidesPerView: 2
						},
						992: {
							slidesPerView: 3
						}
					},
					on: {
						beforeInit: () => {
							this.setClasses();
						},
						afterInit: () => {
							this.setSlidesHeight();
						}
					}
				}

				if (options.breakpoints) {
					if (Number.parseInt(<string>this.swiperEl.dataset.count) < 3) {
						options.breakpoints[576].loop = false;
					}

					if ((Number.parseInt(<string>this.swiperEl.dataset.count)) < 4) {
						options.breakpoints["992"].loop = false;
					}
				}

				new Swiper(this.swiperEl, options);
			}
		}
	}

	setClasses() {
		if (this.swiperSlideEl) {
			this.swiperSlideEl.forEach((item) => {
				item.classList.add('swiper-slide');
			});
		}
	}

	setSlidesHeight() {
		let heightWrap = 0;
		let heightLink = 0;
		this.swiperSlideEl.forEach((item) => {
			let slideHeight = item.clientHeight;
			let linkHeight = item.querySelector('.woocommerce-loop-product__link')?.clientHeight || 0;
			if (slideHeight > heightWrap) {
				heightWrap = slideHeight;
			}
			if (linkHeight > heightLink) {
				heightLink = linkHeight;
			}
		});

		(<NodeListOf<HTMLElement>>this.sliderEl.querySelectorAll('.product-wrap')).forEach(item => {
			item.style.height = heightWrap + "px";
			(<HTMLElement>item.querySelector('.woocommerce-loop-product__link')).style.height = heightLink + "px";
		});
	}
}
